import React, { useEffect, useState } from 'react';
import { DialogOverlay, DialogContent } from '@reach/dialog';
import { Link, useHistory } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import Loader from 'components/Loader';
import Tables, { DataCell } from 'components/Tables';
import { useForm } from 'react-hook-form';

import 'react-toastify/dist/ReactToastify.css';
import '@reach/dialog/styles.css';
import configData from 'config.json';
import Label from 'components/Label';

const Mensajes = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState('Renta tu palco/butacas para el siguiente juego de [ ] en el estadio [ ]. Te comparto el link con todas las opciones disponibles para que les eches un vistazo!');
  const [qr, setQr] = useState('');
  const [status, setStatus] = useState('');
  const [users, setUsers] = useState([]);
  const [loader, setLoader] = useState(true);
  const [contacts, setContacts] = useState([]);

  const [show, setShow] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [showTags, setShowTags] = useState(false);
  const [selectedUser, setSelectedUser] = useState();

  const [tags, setTags] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [excludeTags, setExcludeTags] = useState([]);

  const [total, setTotal] = useState('');
  const [mode, setMode] = useState('add');


  const history = useHistory();


  const [include, setInclude] = useState([]);
  const [exclude, setExclude] = useState([]);
  const segmentos = ['Con propiedades','Sin propiedades','Han rentado','Nunca ha rentado'];
  const [selected, setSelected] = useState({
    name: '',
    tel: ''
  })

  const { register, handleSubmit, errors } = useForm();

  const onSubmit = async data => {
    document.querySelector('#submit').disable = true;
    if(mode == 'add'){
      try {
     
        const res = await axios.post(`${configData.SERVER_URL}/contact`, {
          name: data.name,
          tel: data.tel,
          tags: selected.tags
        });
        if(res.status == 201){
          toast.success('Contacto agregado')
        }else{
          toast.error('Error al crear contacto')
        }
        
        //history.push('/managerPalco');
        history.go(0);
      } catch (err) {
        console.log(err);
      }
    }else{
      try {
     
        const res = await axios.put(`${configData.SERVER_URL}/contact/${selected._id}`, {
          name: data.name,
          tel: data.tel,
          tags: selected.tags
        });
        if(res.status == 200){
          toast.success('Contacto actualizado')
        }else{
          toast.error('Error al actualizar contacto')
        }
        
        //history.push('/managerPalco');
        history.go(0);
      } catch (err) {
        console.log(err);
      }
    }
    getContacts()

  };
   
  const filtrarUsuarios = (users) => {
    // Función auxiliar para evaluar condiciones
    const cumpleCondicion = (user, condition) => {
      switch (condition) {
        case "Con propiedades":
          return user.propietario;
        case "Sin propiedades":
          return !user.propietario;
        case "Han rentado":
          return user.ha_rentado;
        case "Nunca ha rentado":
          return !user.ha_rentado;
        default:
          return false;
      }
    };
  
    // Si no hay include ni selectedTags, incluir todos los usuarios y solo aplicar exclusiones
    let filtrados = (include.length === 0 && selectedTags.length === 0) 
      ? [...users] 
      : users.filter(user => {
          const cumpleInclusion = include.length > 0 && include.some(condition => cumpleCondicion(user, condition));
          const tieneTagSeleccionado = selectedTags.length > 0 && user.tags?.some(tag => selectedTags.map(t => t.toLowerCase()).includes(tag.toLowerCase()));
          return cumpleInclusion || tieneTagSeleccionado;
        });
  
    // Excluir usuarios que cumplan alguna condición en exclude
    if (exclude.length > 0) {
      filtrados = filtrados.filter(user => 
        !exclude.some(condition => cumpleCondicion(user, condition))
      );
    }
  
    // Excluir los que tengan algún tag en excludeTags
    if (excludeTags.length > 0) {
      const tagsExcluir = excludeTags.map(tag => tag.toLowerCase());
      filtrados = filtrados.filter(user =>
        !user.tags?.some(tag => tagsExcluir.includes(tag.toLowerCase()))
      );
    }
  
    return filtrados;
  };


  const filtrarContactos = (contacts) => {
    // Si no hay include ni selectedTags, incluir todos los contactos y solo aplicar exclusiones
    let contactosFiltrados = (include.length === 0 && selectedTags.length === 0) 
      ? [...contacts] 
      : contacts.filter(contact => {
          const cumpleInclusion = include.length > 0 && (
            (include.includes("Con propiedades") && contact.propietario) ||
            (include.includes("Han rentado") && contact.ha_rentado)
          );

          const tieneTagSeleccionado = selectedTags.length > 0 && 
            contact.tags?.some(tag => selectedTags.map(t => t.toLowerCase()).includes(tag.toLowerCase()));

          return cumpleInclusion || tieneTagSeleccionado;
        });

    // Aplicar exclusión de contactos según condiciones
    if (exclude.length > 0) {
      contactosFiltrados = contactosFiltrados.filter(contact => !(
        (exclude.includes("Sin propiedades") && !contact.propietario) ||
        (exclude.includes("Nunca ha rentado") && !contact.ha_rentado)
      ));
    }

    // Excluir contactos con tags en excludeTags
    if (excludeTags.length > 0) {
      const tagsExcluir = excludeTags.map(tag => tag.toLowerCase());
      contactosFiltrados = contactosFiltrados.filter(contact =>
        !contact.tags?.some(tag => tagsExcluir.includes(tag.toLowerCase()))
      );
    }

    return contactosFiltrados;
  };


  const handleSendMessage = async (e) => {
    e.preventDefault();
  
    if (!message) {
      toast.info('Ingrese un mensaje');
      return;
    }
  
    let mensajeEnviado = false;


    const usuariosFiltrados = filtrarUsuarios(users);
  
    for (const user of usuariosFiltrados) {
      if (user.role !== 'admin' && user.tel) {
        // Limpiar el teléfono
        const phone = user.tel.replace(/[\s\-()]/g, '').replace('+52','');
        
        if (validarTelefono(phone)) {

          try {
            // Hacer la petición para enviar el mensaje 
            await axios.post(`${configData.SERVER_URL}/messages/send-message`, {
              number: `521${phone}`,  // Asegúrate de enviar también el número
              message,
            });
  
            toast.success('Mensaje enviado correctamente a: ' + phone);
            mensajeEnviado = true;
          } catch (error) {
            console.log(error);
            toast.error('Fallo al enviar mensaje a: ' + phone);
          }
        } else {
          toast.error('Teléfono inválido: ' + phone);
        }
      }
    }
   

    const contactosFiltrados = filtrarContactos(contacts);
    console.log('Enviado a')
    console.log(contactosFiltrados)

    console.log(usuariosFiltrados)

    for (const contact of contactosFiltrados) {
      if (contact.tel) {
        // Limpiar el teléfono
        const phone = contact.tel.replace(/[\s\-()]/g, '').replace('+52','');
        
        if (validarTelefono(phone)) {
          try {
            // Hacer la petición para enviar el mensaje 
            await axios.post(`${configData.SERVER_URL}/messages/send-message`, {
              number: `521${phone}`,
              message,
            });
  
            toast.success('Mensaje enviado correctamente a: ' + phone);
          } catch (error) {
            console.log(error);
            toast.error('Fallo al enviar mensaje a: ' + phone);
          }
        } else {
          toast.error('Teléfono inválido: ' + phone);
        }
      }
    }
  
    // Limpiar el mensaje si al menos un mensaje fue enviado
    if (mensajeEnviado) {
      setMessage('');
      setIsOpen(false);
    }
  }

  function validarTelefono(telefono) {
    const regexTelefono = /^\+?[0-9]+$/;
    const longitudValida = telefono.replace(/\D/g, '').length >= 10; 
    console.log(longitudValida)
    return regexTelefono.test(telefono) && longitudValida;
  }

  const getContacts = async () => {
    try {
      const users = await axios
        .get(`${configData.SERVER_URL}/user`)
        .then((res) => {
          return res.data.users;
        });
      console.log(users);
      setUsers(users);
    } catch (err) {
      console.log(err);
    }

    try {
      const contacts = await axios
        .get(`${configData.SERVER_URL}/contact`)
        .then((res) => {
          return res.data;
        });
      setContacts(contacts);
    } catch (err) {
      console.log(err);
    }

  }

  const getClient = async () => {
    
    try {
      const res = await axios.get(`${configData.SERVER_URL}/messages/initialize`);
     
      if (res.data.qr) {
        setQr(res.data.qr);
        toast.success('QR Actualizado');
      }
      if (res.data.status) {
        if (res.data.status === 'initializing' || res.data.status === 'qr') {
          setInterval(() => getClient(), 30000);
          if (res.data.status === 'initializing') {
            toast.success('Obteniendo QR');
          }
        } else if (res.data.status === 'ready') {
          setQr('');
          setStatus('ready');
          getContacts();
        }
      }
    } catch (error) {
      console.log('Cliente error', error);
      toast.error('Error al obtener el cliente');
    }
  };

  const deleteContact = async () =>{
    try {
     
      const res = await axios.delete(`${configData.SERVER_URL}/contact/${selected._id}`);
      if(res.status == 200){
        toast.success('Contacto eliminado')
      }else{
        toast.error('Error al eliminar contacto')
      }
      
      //history.push('/managerPalco');
      history.go(0);
      getContacts()
    } catch (err) {
      console.log(err);
    }
  }

  const titleHeadersConfirmation = ['Nombre', 'Teléfono', 'Acciones'];


  useEffect(() => {
    const fetchStatus = async () => {
      await getClient();
    };
    if (status !== 'ready') {
      fetchStatus();
      
    }
   
    setLoader(false);
    console.log(status);
  }, [status]);

  useEffect(()=>{
    const userTags = (users ?? []).flatMap(user => user.tags || []);
    const contactTags = (contacts ?? []).flatMap(contact => contact.tags || []);
  
    const allTags = [...userTags, ...contactTags]
      .map(tag => tag.toLowerCase()) 
      .filter((tag, index, self) => self.indexOf(tag) === index); 
  
      console.log(allTags);
    setTags(allTags);
  },[users, contacts]);

  useEffect(()=>{
    const countUser = users ? filtrarUsuarios(users).length : 0;
    const countContact = contacts ? filtrarContactos(contacts).length : 0;
  
    setTotal(countUser + countContact);
  },[selectedTags,include,exclude,excludeTags]);




  if (!loader) {
    return (
      <span className="af-view">
        <div className="w-full pt-28 messages">
          <ToastContainer />
          <h1>Mensajes masivos</h1>

          {status !== '' ? (
            <div className='messages-wrapper'>

              <h4>Lista de contactos</h4>
              <span>
                <button className='af-class-navbar-accessbutton w-button' onClick={()=>{setSelected({name: '', tel: '', tags: []}); setMode('add'); setShow(true);}}>Agregar</button>
                <button className='af-class-navbar-accessbutton w-button' onClick={() =>{setIsOpen(true)}}>Enviar mensaje</button>
              </span>  
              
              <Tables
                className="w-auto w-table"
                headers={titleHeadersConfirmation}
              >
                {users &&
                  users.map((user, idx) => {
                    
                    return (
                      <tr>
                        <DataCell className="truncate">
                          {user.name} {user.last_name}
                        </DataCell>
                        <DataCell className="truncate">{user.tel}</DataCell>
                        <DataCell>
                          <button className='btn-edit' onClick={()=>{ setSelectedUser(user); setShowTags(true);}}>Etiquetas</button> 
                        </DataCell>
                      </tr>
                    );
                  
                  })
                }
                {contacts && 
                  contacts.map((contact, idx) => {
                      
                    return (
                      <tr>
                        <DataCell className="truncate">
                          {contact.name}
                        </DataCell>
                        <DataCell className="truncate">{contact.tel}</DataCell>
                        <DataCell>
                          <button className='btn-edit' onClick={()=>{ setMode('edit'); setSelected(contact); setShow(true);}}>Editar</button> 
                          <button className='btn-delete' onClick={()=>{setSelected(contact); setConfirm(true)}}>Eliminar</button>
                        </DataCell>
                       
                      </tr>
                    );
                
                  })

                }

              </Tables>

              


            </div>
          ) : (
            <>
              <div className="messages-qr">
                {qr !== '' ? (
                  <img src={qr} width="300" alt="QR Code" />
                ) : (
                  <p>Obteniendo QR</p>
                )}
                <button className='af-class-navbar-accessbutton w-button' onClick={() => getClient()}>Actualizar Qr</button>
              </div>
            </>
          )}
        </div>

        <DialogOverlay
          aria-label="Enviar mensaje"
          isOpen={isOpen}
          onDismiss={() => setIsOpen(false)}
          className="z-40 border"
        >
          <DialogContent
            className="container rounded-lg"
            aria-labelledby="dialog-content"
            style={{ width: '50%' }}
          >
            <h2>Enviar un mensaje</h2>
            <form onSubmit={handleSendMessage}>
              <textarea
                placeholder="Ingrese su mensaje"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                required
                rows={5}
                className="af-class-form-textinput w-input"
              />

              <CheckboxGroup
                title={'Incluir'}
                options={segmentos}
                selectedOptions={include}
                setSelectedOptions={setInclude}
                groupName={'inc'}

              />
              <hr/>
              <CheckboxGroup
                title={''}
                options={tags}
                selectedOptions={selectedTags}
                setSelectedOptions={setSelectedTags}
                groupName={'tags'}
              />


              <CheckboxGroup
                title={'Excluir'}
                options={segmentos}
                selectedOptions={exclude}
                setSelectedOptions={setExclude}
                groupName={'exc'}

              />

              <CheckboxGroup
                title={''}
                options={tags}
                selectedOptions={excludeTags}
                setSelectedOptions={setExcludeTags}
                groupName={'exTags'}
              />

              

              <button type="submit"  className="af-class-navbar-accessbutton w-button">
                {`Enviar  ${total != 0 ? ' a '+total : ''}`}
              </button>
              <button type="button" className="af-class-button ml-2" onClick={() => setIsOpen(false)}>Cancelar</button>
            </form>
          </DialogContent>
        </DialogOverlay>

        <DialogOverlay
          aria-label="Formulario"
          isOpen={show}
          onDismiss={() => setShow(false)}
          className="z-40 border"
        >
          <DialogContent
            className="container rounded-lg"
            aria-labelledby="dialog-content"
            style={{ width: '50%' }}
          >
            <h2>{mode == 'add' ? 'Agregar' : 'Editar'}</h2>
            <form onSubmit={handleSubmit(onSubmit)}>

              <div className="af-class-form-field-wrapper">
                <label
                  htmlFor="name-2"
                  className="af-class-form-label"
                >
                  Nombre(s) *
                </label>
                <input
                  ref={register} 
                  type='text'
                  placeholder='Nombre'
                  name='name'
                  required
                  defaultValue={selected.name}
                  className="af-class-form-textinput w-input"
                />
                {errors.name && <span>El nombre es requerido</span>}
                
              </div>

              <div className="af-class-form-field-wrapper">
                <label
                  htmlFor="name-2"
                  className="af-class-form-label"
                >
                  Número telefónico
                </label>
                <input
                  ref={register} 
                  type='tel'
                  placeholder='Télefono'
                  defaultValue={selected.tel}
                  name='tel'
                  required 
                  minLength={10}
                  className="af-class-form-textinput w-input"
                />
                {errors.tel && <span>Ingrese un teléfono válido</span>}

              </div>

              <ContactTags contact={selected} setSelected={setSelected} getContacts={getContacts} />


              <button type="button" className="af-class-button mr-2" onClick={() => setShow(false)}>Cancelar</button>

              <input type="submit" className='w-button' value='Enviar' id='submit' />
              
              
            </form>
          </DialogContent>
        </DialogOverlay>

        <DialogOverlay
          aria-label="Etiquetas de usuarios"
          isOpen={showTags}
          onDismiss={() => setShowTags(false)}
          className="z-40 border"
        >
          <DialogContent
            className="container rounded-lg"
            aria-labelledby="dialog-content"
            style={{ width: '50%' }}
          >
            {selectedUser &&
              <>
                <h2>Etiquetas {selectedUser.name}</h2>
               
                <TagComponent selected={selectedUser.tags} id={selectedUser._id} handleClose={()=>setShowTags(false)} getContacts={getContacts}/>

              </>
            }
          </DialogContent>
        </DialogOverlay>

        <DialogOverlay
          aria-label="Confirmar borrado"
          isOpen={confirm}
          onDismiss={() => setConfirm(false)}
          className="z-40 border"
        >
          <DialogContent
            className="container rounded-lg"
            aria-labelledby="dialog-content"
            style={{ width: '50%' }}
          >
            <h5>Estás por eliminar <strong>DEFINITIVAMENTE</strong> el contacto: <strong>{selected.name}</strong></h5>
            

            <button className="af-class-navbar-accessbutton w-button" onClick={()=>deleteContact()}>
                Confirmar
            </button>
            <button type="button" className="af-class-button ml-2" onClick={() => setConfirm(false)}>Cancelar</button>


          </DialogContent>
        </DialogOverlay>


      </span>
    );
  } else {
    return <Loader />;
  }
};


const CheckboxGroup = ({ options, selectedOptions, setSelectedOptions, groupName, title }) => {
  
  const handleCheckboxChange = ({ target: { name, checked } }) => {
    setSelectedOptions(prev =>
      checked ? [...new Set([...prev, name])] : prev.filter(option => option !== name)
    );
  };

  return (
    <div className="checkboxes">
      <Label className="text-deep-blue">{title}</Label>
      <div className="checkboxes-list">
        {options.map((option, index) => (
          <div className={`c-check ${title === "Excluir" ? "-red" : ""}`} key={`${groupName}-${option}-${index}`}>
            <input
              id={`${groupName}-${option}`}
              name={option}
              type="checkbox"
              checked={selectedOptions.includes(option)}
              onChange={handleCheckboxChange}
            />
            <label htmlFor={`${groupName}-${option}`}>
              {option.charAt(0).toUpperCase() + option.slice(1)}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

const TagComponent = ({ selected = [], id, handleClose, getContacts }) => {
  const [newTag, setNewTag] = useState("");
  const [localTags, setLocalTags] = useState(selected);
  const [isModified, setIsModified] = useState(false);

  const addTag = () => {
    const trimmedTag = newTag.trim();
    if (!trimmedTag || localTags.includes(trimmedTag)) return;
    setLocalTags([...localTags, trimmedTag]);
    setNewTag("");
    setIsModified(true);
  };

  const removeTag = (tag) => {
    setLocalTags(localTags.filter((t) => t !== tag));
    setIsModified(true);
  };

  const saveTags = async () => {
    try {
      await axios.put(`${configData.SERVER_URL}/user/${id}/tags`, {
        tags: localTags,
      });
      toast.success("Etiquetas guardadas");
    } catch (e) {
      toast.error("Error al guardar etiquetas");
      console.log(e);
    }
    setIsModified(false);
    getContacts()
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Evita el comportamiento por defecto del formulario
      addTag();
    }
  };

  return (
    <div className="tags-component">
      <div>
        {localTags.map((tag) => (
          <span className='tag' key={tag} style={{ margin: "5px", padding: "5px", border: "1px solid #ccc" }}>
            {tag} <button onClick={() => removeTag(tag)}>x</button>
          </span>
        ))}
      </div>
      <input
        value={newTag}
        onChange={(e) => setNewTag(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Nuevo tag"
        className="af-class-form-textinput w-input"
      />
       <button type="button" className="af-class-button mr-2" onClick={handleClose}>Cancelar</button>
      {isModified && <button className='w-button' onClick={saveTags}>Guardar cambios</button>}
    </div>
  );
};

const ContactTags = ({ contact , setSelected , getContacts}) => {
  const [newTag, setNewTag] = useState("");


  const addTag = () => {
    const trimmedTag = newTag.trim();
    if (!trimmedTag || contact.tags.includes(trimmedTag)) return;
    setSelected(contact => ({ ...contact, tags: [...contact.tags, trimmedTag] }));
    setNewTag("");
    getContacts();
  };

  const removeTag = (tag) => {
    setSelected(contact => ({ ...contact, tags: contact.tags.filter((t) => t !== tag) }));
    getContacts()
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      addTag();
    }
  };

  return(
    <div className="af-class-form-field-wrapper tags-component">
      <label className="af-class-form-label">Etiquetas</label>
      <div>
        {contact.tags.map((tag) => (
          <span className='tag' key={tag} style={{ margin: "5px", padding: "5px", border: "1px solid #ccc" }}>
            {tag} <button type="button" onClick={() => removeTag(tag)}>x</button>
          </span>
        ))}
      </div>
      <input
        value={newTag}
        onChange={(e) => setNewTag(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder="Nuevo tag"
        className="af-class-form-textinput w-input"
      />
    </div>
  )
}




export default Mensajes;
